import { Injectable, ElementRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollToRefService {
  static scroll(ref: ElementRef = undefined, correctionOfScroll: number = 20, yScrollMovement: number = 0) {
    if (!ref || !ref.nativeElement) {
      ScrollToRefService.smoothScrollToFallback(0);
      return;
    }

    const fixedHeaderHeight = 58;
    const target = ref.nativeElement;
    const targetHeight = target.offsetHeight;
    const windowHeight = window.innerHeight;

    const targetTopFromViewport = target.getBoundingClientRect().top + yScrollMovement;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetTopFromPageTop = targetTopFromViewport + scrollTop;

    const targetBottomEdgeFromViewportTop = targetTopFromViewport + targetHeight;
    const targetBottomFromPageTop = targetTopFromPageTop + targetHeight;

    if (targetBottomEdgeFromViewportTop > windowHeight - correctionOfScroll) { // Does user see the bottom of reference?

      setTimeout(() => {
        ScrollToRefService.smoothScrollToFallback(Math.min(
          targetBottomFromPageTop - windowHeight + correctionOfScroll, // scroll to see the bottom edge of the element ...
          targetTopFromPageTop - fixedHeaderHeight - correctionOfScroll // ... but not too much to see the scroll edge as the priority
        ));
      }, 1);

    } else if (targetTopFromViewport < fixedHeaderHeight + correctionOfScroll) { // Does user see the top of reference?

      setTimeout(() => {
        ScrollToRefService.smoothScrollToFallback(targetTopFromPageTop - fixedHeaderHeight - correctionOfScroll);
      }, 1);

    }
  };

  /**
   * Regular window.scrollTo({behavior: "smooth"}) causes a bug, when any element appears between the current
   * top/bottom window edge and the scrolling point. Confirmed in the internet.
   * Bug in Chrome and Firefox - perhaps more.
        window.scrollTo({
          top: 500,
          left: 0,
          behavior: "smooth"
        });
   */
  static smoothScrollToFallback(endY, endX = 0, duration = 300) {
    let startX = window.scrollX || window.pageXOffset,
      startY = window.scrollY || window.pageYOffset,
      distanceX = endX - startX,
      distanceY = endY - startY,
      startTime = new Date().getTime();

    // Easing function
    let easeInOutQuart = function(time, from, distance, duration) {
      if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
      return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
    };

    let timer = window.setInterval(function() {
      let time = new Date().getTime() - startTime,
        newX = easeInOutQuart(time, startX, distanceX, duration),
        newY = easeInOutQuart(time, startY, distanceY, duration);
      if (time >= duration) {
        window.clearInterval(timer);
      }
      window.scrollTo(newX, newY);
    }, 1000 / 60); // 60 fps
  };

  static getOffsetTop(elem) {
    let offsetTop = 0;
    do {
      if (!isNaN(elem.offsetTop)) {
        offsetTop += elem.offsetTop;
      }
    } while (elem = elem.offsetParent);
    return offsetTop;
  }

  static absScroll(ref: ElementRef = undefined, move: number = 0) {
    if (!ref || !ref.nativeElement) {
      ScrollToRefService.smoothScrollToFallback(move);
      return;
    }

    const target = ref.nativeElement;
    const targetOffsetTop = this.getOffsetTop(target);

    this.smoothScrollToFallback(targetOffsetTop + move);
  }
}
